import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DeleteaddressComponent } from '../../../dialogs/client-address/deleteaddress/deleteaddress.component';
import { MediaObserver } from '@angular/flex-layout';
import { MyStripeService } from 'src/app/services/apiclient/myStripe/my-stripe.service';
import { StripeCardScaComponent } from 'src/app/components/dialogs/stripe-card-sca/stripe-card-sca.component';

@Component({
  selector: 'app-cards-backoffice-client',
  templateUrl: './cards-backoffice-client.component.html',
  styleUrls: ['./cards-backoffice-client.component.css']
})
export class CardsBackofficeClientComponent implements OnInit {
  @Output() setClientCardsEvent = new EventEmitter<any[]>();

  @Input()
  clientCards$: any;

  @Input()
  from: string | any;

  cardClient$: any;

  // RESPONSIVE
  respCols: any = {
    "xs": 1,
    "sm": 2,
    "md": 2,
    "lg": 3,
    "xl": 4
  };

  currCols: number = (this.media.isActive("xs")) ? 1 : 2;
  rowHeight: number = 150;
  loader: boolean = true;
  defaultStripePayMethod: any;
  obserdefault: any;
  @ViewChild('menuTrigger') trigger:any;


  constructor(
    private dialog: MatDialog,
    private media: MediaObserver,
    private cardApi: MyStripeService
  ) {
    this.media.asObservable().subscribe((media: any) => {
      this.currCols = this.respCols[media.mqAlias];
    });

    this.obserdefault = this.cardApi.getDefaultPaymentMethodObser().subscribe(defaultStripePayMethod => {
      this.defaultStripePayMethod = defaultStripePayMethod;

    });



  }

  ngOnInit() {
    if (this.from !== "client") {
      this.cardApi.getCurrCard().subscribe(card => {
        this.cardClient$ = card;
      });
    }

  }
  ngOnDestroy(): void {
    if (this.obserdefault) {
      this.obserdefault.unsubscribe();
    }

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["clientCards$"].currentValue) {
      this.clientCards$ = changes["clientCards$"].currentValue;
  
      this.loader = false;
    }
  }

  selectCardClient(card: any) {
   
    if (this.from !== "client") {
      this.cardApi.setCurrCard(card);
    }
  }

  openDialCardSca() {
    const myConf = new MatDialogConfig();
    this.media.isActive("xs")
        ? (myConf.width = "100%", myConf.height = "100%")
        : (myConf.width = "550px", myConf.height = "80%");
    const myDial = this.dialog.open(StripeCardScaComponent, myConf);
    myDial.afterClosed().subscribe(result => {
      if (result) {
        if (result.from === "saved") {
          this.setClientCards(result.cards);
        } else if (result.from === "momentary") {
          this.clientCards$.push(result.card);
          this.setClientCards(this.clientCards$);
        }
      }
    });
  }

  openDialDeletCard(card: any, index: number) {
    this.trigger.closeMenu()
    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.data = {
      from: "card",
      card: card,
      cards: this.clientCards$,
      index: index,
      currCard: this.cardClient$
    };
    this.media.isActive("xs") ? myConf.width = "100%" : myConf.width = "500px";
    const myDial = this.dialog.open(DeleteaddressComponent, myConf);
    myDial.afterClosed().subscribe(data => {
      if (data) {


        this.setClientCards(data);
      }
    });
  }

  setClientCards(cards: any[]) {

    this.setClientCardsEvent.emit(cards);
  }



  setDefaultPaymentStripeMethod(paiement_method: any, $event: any) {

    this.cardApi.setDefaultPaymentMethodObser(paiement_method);
    this.cardApi.updateCustomerPaymentsMethod(paiement_method.id).subscribe(customer_updated => {

    });
  }

 
}
